import React, { createContext, useContext } from "react";

type AppContextValue = Record<string, unknown>;

const AppContext = createContext<AppContextValue>({});

export const useAppContext = () => useContext(AppContext);

export const AppContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <AppContext.Provider value={{}}>{children}</AppContext.Provider>;
